import { BENEFICIARY_TYPES } from '../../../../settings/settings';

export const typeInput = {
  prop: 'entityType',
  label: 'Type',
  input: 'dropdown',
  required: true,
  options: [
    {
      label: 'Individual',
      value: BENEFICIARY_TYPES.INDIVIDUAL,
    },
    {
      label: 'Entity',
      value: BENEFICIARY_TYPES.ENTITY,
    },
  ],
};

const Name = {
  prop: 'name',
  label: 'Name',
  input: 'text',
  required: true,
  charPattern: /^[-@./#&+! \w]*$/,
  maxLength: 60,
};

const firstName = {
  prop: 'firstName',
  label: 'First Name',
  input: 'text',
  charPattern: /[a-zA-Z\s]/,
  required: true,
  cleaveOptions: {
    blocks: [20],
  },
};

const middleInitial = {
  prop: 'middleName',
  label: 'Middle Name',
  input: 'text',
  cleaveOptions: {
    blocks: [20],
  },
};

const lastName = {
  prop: 'lastName',
  label: 'Last Name',
  input: 'text',
  charPattern: /[a-zA-Z\s]/,
  required: true,
  cleaveOptions: {
    blocks: [20],
  },
};

const suffix = {
  prop: 'suffix',
  label: 'Suffix',
  input: 'dropdown',
  options: [
    {
      label: '--',
      value: '',
    },
    {
      label: 'Jr',
      value: 'jr',
    },
    {
      label: 'Sr',
      value: 'sr',
    },
    {
      label: 'I',
      value: 'I',
    },
    {
      label: 'II',
      value: 'II',
    },
    {
      label: 'III',
      value: 'III',
    },
    {
      label: 'IV',
      value: 'IV',
    },
    {
      label: 'V',
      value: 'V',
    },
  ],
  default: '',
};

const relationship = {
  prop: 'relationship',
  label: 'Relationship',
  input: 'dropdown',
  required: true,
  options: [
    {
      label: 'Parent',
      value: 'parent',
    },
    {
      label: 'Spouse',
      value: 'spouse',
    },
    {
      label: 'Child',
      value: 'child',
    },
    {
      label: 'Sibling',
      value: 'sibling',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ],
};

const relationshipEntity = {
  prop: 'relationship',
  label: 'Relationship',
  input: 'dropdown',
  required: true,
  options: [
    {
      label: 'Entity',
      value: 'entity',
    },
  ],
  default: 'entity',
};

const ssn = {
  prop: 'taxId',
  label: 'SSN/TIN',
  input: 'text',
  cleaveOptions: {
    delimiters: ['-', '-'],
    blocks: [3, 2, 4],
  },
};

const tin = {
  prop: 'taxId',
  label: 'SSN/TIN',
  input: 'text',
  cleaveOptions: {
    delimiters: ['-'],
    blocks: [2, 7],
  },
};

const dateOfBirth = {
  prop: 'dateOfBirth',
  label: 'Date of Birth',
  input: 'text',
  placeholder: 'mm/dd/yyyy',
  cleaveOptions: {
    date: true,
    delimiter: '/',
    datePattern: ['m', 'd', 'Y'],
  },
};

const percentage = {
  prop: 'distribution',
  label: 'Percentage',
  input: 'percent',
  required: true,
};

export const inputsConfig = {
  individual: [
    firstName,
    middleInitial,
    lastName,
    suffix,
    relationship,
    ssn,
    dateOfBirth,
    percentage,
  ],
  entity: [Name, relationshipEntity, tin, percentage],
};
